import { SideBarWrapper } from "./styled"
import NoAvatar from "assets/images/no-avatar.png"
import NoAvatarFound from "assets/images/no-image-found.png"
import { FaClipboard, FaLock, FaTelegramPlane, FaUpload, FaSave, FaTimes } from "react-icons/fa";
import ButtonIcon from "components/ButtonIcon";
import Input from "components/Input";
import { useState } from "react";
import { useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ErrorMessage from "components/ErrorMessage";
import ShowToast from "utils/ShowToast";
import { authAction } from "redux/slice/authSlice"
import { useDispatch, useSelector } from "react-redux";
import { authSelector } from "redux/selector";
import { role } from "common/general"

const SideBar = ({ data }) => {
    const [editAvatar, setEditAvatar] = useState(false)
    const [errorAvatar, setErrorAvatar] = useState("")
    const [avatar, setAvatar] = useState(data.avatar)
    const dispatch = useDispatch()
    const avatarRef = useRef()
    const navigate = useNavigate()
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const qPage = query.get("page");
    const authState = useSelector(authSelector)

    const handleChangeAvatar = () => {
        if (avatar && avatar.trim() !== "") {
            setErrorAvatar("")
            const data = {
                avatar
            }
            dispatch(authAction.changeAvatar({ data, ShowToast }))
            setEditAvatar(false);
        } else {
            setErrorAvatar("Vui lòng nhập đường dẫn ảnh")
        }
    }
    const handleExit = () => {
        setEditAvatar(false);
        setAvatar(data.avatar);
        setErrorAvatar("")
    }
    return (
        <SideBarWrapper className="bg-grey2">
            <div className="avatar flex-center pt-15 pb-10">
                <div className="avatar_image">
                    <img src={authState.currentUser?.user.avatar || NoAvatar} ref={avatarRef} onError={() => avatarRef.current.src = NoAvatarFound} className="b-grey-1" alt="avatar" />
                    {/* {
                        !editAvatar &&
                        <ButtonIcon classButton="edit_img action-success" icon={<FaUpload />} description="Đổi ảnh đại diện" onClick={() => setEditAvatar(true)} />
                    } */}
                    {/* {
                        editAvatar &&
                        <div className="flex-center avatar_control">
                            <ButtonIcon classButton="save_img action-primary" icon={<FaSave />} description="Lưu" onClick={handleChangeAvatar} />
                            <ButtonIcon classButton="exit_img action-success ml-10" icon={<FaTimes />} description="Thoát" onClick={handleExit} />
                        </div>
                    } */}
                </div>
            </div>
            {
                editAvatar &&
                <div className="px-15 mb-15">
                    {
                        errorAvatar &&
                        <ErrorMessage>{errorAvatar}</ErrorMessage>
                    }
                    <Input className="input_avatar" placeholder="Nhập đường dẫn ảnh" value={avatar ?? ""} onChange={e => setAvatar(e.target.value.trim())} />
                </div>
            }
            <div className="text-red bold s-22 text-center pb-15 bb-grey-1">{data.account_name}</div>
            <div className="sidebar_list mt-15 pb-15">
                <ul className="list px-0">
                    <li className={`list_item clickable px-15 py-5  text-link-hover ${!qPage || qPage === "me" ? "bg-orange text-white" : "text-link"} `} onClick={() => navigate("/my-page?page=me")}>
                        <FaClipboard className="mr-10" width={20} height={20} />
                        <span className="s-18">Thông tin cá nhân</span>
                    </li>
                    <li className={`list_item clickable px-15 py-5  text-link-hover ${qPage === "change-password" ? "bg-orange text-white" : "text-link"} `} onClick={() => navigate("/my-page?page=change-password")}>
                        <FaLock className="mr-10" width={20} height={20} />
                        <span className="s-18">Đổi mật khẩu</span>
                    </li>
                    {
                        authState.role === role.CUSTOMER &&
                        <li className={`list_item clickable px-15 py-5  text-link-hover ${qPage === "tour" ? "bg-orange text-white" : "text-link"} `} onClick={() => navigate("/my-page?page=tour")}>
                            <FaTelegramPlane className="mr-10" width={20} height={20} />
                            <span className="s-18">Quản lý tour</span>
                        </li>
                    }
                </ul>
            </div>
        </SideBarWrapper>
    )
}

export default SideBar